import {
  appendQueryParameters,
  fetchBaseQueryWrapper,
  NO_CACHING,
} from "@/services/helpers";
import { createApi } from "@reduxjs/toolkit/query/react";

export const issuesApi = createApi({
  reducerPath: "issuesApi",
  baseQuery: fetchBaseQueryWrapper(),
  keepUnusedDataFor: NO_CACHING,
  endpoints: (build) => ({
    getProjectIssues: build.query({
      query: ({ publicProjectId, queryParameters }) =>
        appendQueryParameters(`projects/${publicProjectId}/issues`, queryParameters),
    }),
    createProjectIssue: build.mutation({
      query: ({ publicProjectId, body }) => ({
        url: `projects/${publicProjectId}/issues`,
        method: "POST",
        body,
      }),
    }),
    createProjectIssueFromRisk: build.mutation({
      query: ({ publicProjectId, publicProjectRiskId }) => ({
        url: `projects/${publicProjectId}/issues/from-risk/${publicProjectRiskId}`,
        method: "POST",
      }),
    }),
    updateProjectIssue: build.mutation({
      query: ({ publicProjectId, publicProjectIssueId, body }) => ({
        url: `projects/${publicProjectId}/issues/${publicProjectIssueId}`,
        method: "PUT",
        body,
      }),
    }),
    deleteProjectIssue: build.mutation({
      query: ({ publicProjectId, publicProjectIssueId }) => ({
        url: `projects/${publicProjectId}/issues/${publicProjectIssueId}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useGetProjectIssuesQuery,
  useCreateProjectIssueMutation,
  useCreateProjectIssueFromRiskMutation,
  useUpdateProjectIssueMutation,
  useDeleteProjectIssueMutation,
} = issuesApi;
